import React from 'react';
import styled from 'styled-components';

interface Props {
  title: string;
  info: Array<any>;
}

const Container = styled.div`
  height: 60pt;
  margin: 0% 0% 0% 40px;
  width: 100%;
  font-family: BrandonGrotesque-Medium, sans-serif;
  line-height: 68pt;
  font-size: 38px;
  letter-spacing: 6px;
  color: var(--color-gunmetal);
`;

const Text = styled.div`
  margin-left: 40px;
  font-family: BrandonGrotesque-Regular, sans-serif;
  letter-spacing: 3px;
  font-size: 17pt;
  color: #333333;
  text-align: left;
`;

function Bar(props: Props) {
  const filtered = props.info.filter((text: Array<string>) => text[1] && text[1] !== '0');

  return (
    <div className="page-break">
      <Container className="bar-container">{props.title}</Container>
      {filtered.length ? (
        <Text>
          {filtered
            .map<React.ReactNode>((text: Array<string>, i) => (
              <span key={i}>
                <span>{text[0]} </span>
                <b>{text[1]} </b>
                <span>{text[2]} </span>
              </span>
            ))
            .reduce((prev, curr) => [prev, '| ', curr])}
        </Text>
      ) : null}
    </div>
  );
}

export default Bar;
